//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import 'react-widgets/lib/less/react-widgets.less'
import './DateRangeContainer.less'

class DateRangeContainer extends Component {
    static propTypes = {
        className: PropTypes.string,

        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element),
        ]),
    };

    static defaultProps = {
        className: '',
    };

    render() {
        const {children, className} = this.props;

        return (
            <div className={`date-picker-parent-container ${className}`}>{children}</div>
        )
    }
}

export default DateRangeContainer



/** WEBPACK FOOTER **
 ** ./src/components/Modules/DateRangeContainer/DateRangeContainer.js
 **/